import styled from 'styled-components';

const SimpleText = styled.span`
  padding-right: 12px;
  font-size: 16px;
`;

export default SimpleText;
